const i18nService = {
  defaultLanguage: "en",

  languages: [
    {
      lang: "en",
      name: "English",
      flag: process.env.BASE_URL + "assets/media/flags/226-united-states.svg",
    },
    {
      lang: "ptbr",
      name: "Português do Brasil",
      flag: process.env.BASE_URL + "assets/media/flags/255-brazil.svg",
    },
    {
      lang: "pt-pt",
      name: "Português (Portugal)",
      flag: process.env.BASE_URL + "assets/media/flags/224-portugal.svg",
    },
    {
      lang: "id",
      name: "Bahasa Indonesia",
      flag: process.env.BASE_URL + "assets/media/flags/209-indonesia.svg",
    },
    {
      lang: "es",
      name: "Español",
      flag: process.env.BASE_URL + "assets/media/flags/128-spain.svg",
    },
    {
      lang: "de",
      name: "Deutsche",
      flag: process.env.BASE_URL + "assets/media/flags/162-germany.svg",
    },
    {
      lang: "fr",
      name: "Français",
      flag: process.env.BASE_URL + "assets/media/flags/195-france.svg",
    },
  ],

  normalizeLanguage(lang) {
    if (!lang) {
      return this.defaultLanguage;
    }

    const normalized = lang.toLowerCase().replace("_", "-");
    if (normalized === "pt-br" || normalized === "ptbr") {
      return "ptbr";
    }

    if (normalized === "pt" || normalized === "pt-pt") {
      return "pt-pt";
    }

    return normalized;
  },

  getApiLanguage(lang) {
    const normalized = this.normalizeLanguage(lang);
    return normalized === "ptbr" ? "pt-br" : normalized;
  },

  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  setActiveLanguage(lang) {
    localStorage.setItem("language", this.normalizeLanguage(lang));
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    if (navigator.languages != undefined) {
      const browserLanguage = navigator.languages[0].toLowerCase();
      const langCode = browserLanguage.slice(0, 2);
      if (langCode == "es") {
        this.defaultLanguage = "es";
      } else if (browserLanguage == "pt-br") {
        this.defaultLanguage = "ptbr";
      } else if (langCode == "pt") {
        this.defaultLanguage = "pt-pt";
      } else if (langCode == "id") {
        this.defaultLanguage = "id";
      } else if (langCode == "de") {
        this.defaultLanguage = "de";
      } else if (langCode == "fr") {
        this.defaultLanguage = "fr";
      }
    }
    return this.normalizeLanguage(
      localStorage.getItem("language") || this.defaultLanguage
    );
  },
};

export default i18nService;
